import React, { useState } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { withRouter } from "react-router";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    marginBottom: "20px",
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  drawerButton: {
    marginLeft: 3,
    marginRight: 20,
  },
  nested: {
    paddingLeft: `${theme.spacing.unit * 2}px !important`,
  },
});

const Element = ({ goTo, primary, className, route, subOptions, classes }) => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const goToRoute = () => {
    goTo(`/${route}`);
  };

  if (subOptions) {
    return (
      <>
        <ListItem button key={route} onClick={handleClick}>
          <ListItemText primary={primary} className={className} />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {Object.keys(subOptions).map((subRoute) => (
              <Element
                goTo={goTo}
                button
                key={`${route}/${subRoute}`}
                route={`${route}/${subRoute}`}
                primary={subOptions[subRoute].name}
                className={classes.nested}
              />
            ))}
          </List>
        </Collapse>
      </>
    );
  } else {
    return (
      <ListItem button key={route} onClick={goToRoute}>
        <ListItemText primary={primary} className={className} />
      </ListItem>
    );
  }
};

Element.propTypes = {
  classes: PropTypes.object.isRequired,
};

const ElementWithStyles = withStyles(styles, { withTheme: true })(Element);

export default withRouter(ElementWithStyles);
